import firebase from "./FirebaseService";

class SupportService {

	async doesHaveActiveChat(uid) {
		
		
		try {
			
			const chat = await firebase.firestore().collection("chats").doc(uid).get();

			return chat.exists;
		}
		catch(error) {
			throw error;
		}
	}

	async createChat(uid) {
		try {
			await firebase.firestore().collection("chats").doc(uid).set({
				lastMessage: new Date()
			});

		}
		catch(error) {
			throw error;
		}
	}

	async getAllChats() {
		try {
			let chats = [];

			const result = await firebase.firestore().collection("chats").orderBy("lastMessage", "desc").get();
			const docs = result.docs;

			for(let i = 0; i < docs.length; i++) {

				const user = await firebase.firestore().collection("users").doc(docs[i].id).get();

				chats.push({
					id: docs[i].id,
					name: user.get("name"),
					lastMessage: docs[i].get("lastMessage")
				});
			}

			return chats;

		}
		catch(error) {
			throw error;
		}
	}
	
}

export default SupportService;